import React, { FC, ReactNode } from 'react';
import Money, { Props as MoneyProps } from '../Money';
import { Currency, CurrencySymbols } from '../../../enums';
import { formatCompactMoneyAmount } from '../../utils';

export type Props = Omit<MoneyProps, 'amountRenderer' | 'currencyRenderer'> & {
	abbreviationThreshold?: number;
	compactAmountRenderer?: (amount: number, currency: string | Currency, abbreviationThreshold: number) => ReactNode;
	compactCurrencyRenderer?: (currency: CurrencySymbols, amount: number, abbreviationThreshold: number) => ReactNode;
};

const CompactMoney: FC<Props> = ({
	/* Если длина строки "цены" >= abbreviationThreshold, сокращаем */
	abbreviationThreshold = 6,
	compactAmountRenderer,
	compactCurrencyRenderer,
	...moneyProps
}) => {
	const amountRenderer = (amount: number, currency: string | Currency) => {
		const render = compactAmountRenderer || formatCompactMoneyAmount;

		return render(amount, currency, abbreviationThreshold);
	};

	const currencyRenderer = compactCurrencyRenderer
		? (currency: CurrencySymbols) =>
				compactCurrencyRenderer(currency, moneyProps?.money?.amount, abbreviationThreshold)
		: undefined;

	return <Money amountRenderer={amountRenderer} currencyRenderer={currencyRenderer} {...moneyProps} />;
};

export default CompactMoney;
